export default "__VITE_ASSET__BBW7x3pK__"